import { Divider, Flex, Form, Typography } from "antd";
import { NOTIFICATION_TYPE_ENUM } from "interfaces";
import { observer } from "mobx-react-lite";
import { useNotificationContext } from "providers";
import { useState } from "react";
import { useStores } from "stores";
import { CustomButton, FileType, FileInput, UploadedFileDisplay } from "ui";
import { parseErrorMessage } from "utils";

type Props = {
  type?: string;
  fn: ({ file, type }: { file: FileType; type?: string }) => Promise<any>;
  successMessage?: string;
  onSuccess?: () => Promise<void>;
};

export const AddTemplatesFileModal = observer(({ type, fn, successMessage, onSuccess }: Props) => {
  const { actionModals } = useStores();
  const { openNotification } = useNotificationContext();
  const [uploadedFile, setUploadedFile] = useState<FileType | null>();
  const [loading, setLoading] = useState(false);

  const handleUploadFile = (files?: FileType[]) => {
    if (files?.length) setUploadedFile(files[0]);
  };

  const handleRemoveDocument = () => {
    setUploadedFile(null);
  };

  const handleAddFile = async () => {
    if (!uploadedFile) return;
    setLoading(true);
    try {
      await fn({ file: uploadedFile, type });
      await onSuccess?.();

      openNotification({
        message: successMessage || `Шаблон обновлён ${uploadedFile.name}`,
        type: NOTIFICATION_TYPE_ENUM.SUCCESS,
      });
      handleCloseModal();
    } catch (error: any) {
      openNotification({
        type: NOTIFICATION_TYPE_ENUM.ERROR,
        description: parseErrorMessage(error),
      });
    } finally {
      setLoading(false);
    }
  };

  const handleCloseModal = () => {
    actionModals.closeAll();
  };

  return (
    <Flex vertical gap="large">
      <Flex vertical>
        <Typography.Title>Загрузите файл</Typography.Title>
        <Divider style={{ margin: 0 }} />
      </Flex>

      {uploadedFile ? (
        <UploadedFileDisplay fileName={uploadedFile.name} onRemove={handleRemoveDocument} tooltip="Удалить" />
      ) : (
        <Flex vertical>
          <FileInput isLocal={handleUploadFile} className="full-width" multiple={false} />
        </Flex>
      )}

      <Form.Item>
        <CustomButton
          htmlType="button"
          disabled={loading || !uploadedFile}
          loading={loading}
          onClick={handleAddFile}
          style={{ width: "100%" }}
        >
          Загрузить
        </CustomButton>
      </Form.Item>
    </Flex>
  );
});
